// extracted by mini-css-extract-plugin
export default {"error":"Page404_error__ZvObI","img":"Page404_img__ag4Qz"};